import ApiService from '@/services/ApiService';
export default {
  login(data) {
    return ApiService().post('/auth', data, true);
  },
  register(data) {
    return ApiService().post('/register', data, true);
  },
  forgot(data) {
    return ApiService().post('/request-reset-password', data, true);
  },
  resetPassword(data) {
    return ApiService().post('/reset-password', data, true);
  },
  changePassword(data) {
    return ApiService().put('/me/password', data, true);
  },
  profileUpdate(data){
    return ApiService().put('/me', data, true);
  },
  descriptionUpdate(data){
    return ApiService().put('/me/short-bio', data, true);
  },
  avatarUpdate(data){
    return ApiService().put('/me/photo', data, true);
  },
  coverUpdate(data){
    return ApiService().put('/me/cover', data, true);
  },
  getMe(){
    return ApiService().get('/me');
  },
  emailExists(email) {
    return ApiService().get('/check-email/'+email)
  },
};
